import "./BudLogo.css";

/**
 * Animated brand mark — girl's lips blowing smoke.
 * SVG-based, fully self-contained, dark/light variants via prop.
 * Sizes:  size="sm" (32) | "md" (40 default) | "lg" (56)
 */
export default function BudLogo({ size = "md", tone = "light", spin = true }) {
  const px = size === "lg" ? 56 : size === "sm" ? 32 : 40;
  const tile = tone === "dark" ? "#15FF73" : "#15FF73";
  const stroke = "#0B0F0C";

  return (
    <span
      className={`bud-logo-wrap inline-flex items-center justify-center relative ${spin ? "bud-spin" : ""}`}
      style={{ width: px, height: px }}
      aria-label="X-Seed"
    >
      <span
        className="absolute inset-0 rounded-2xl"
        style={{ background: tile, border: `2px solid ${stroke}`, boxShadow: `2px 2px 0 ${stroke}` }}
      />

      <svg
        viewBox="0 0 64 64"
        width={px - 6}
        height={px - 6}
        className="relative z-10 bud-svg"
      >
        {/* smoke wisps — animated */}
        <g className="bud-smoke" opacity="0.85">
          <circle className="puff p1" cx="32" cy="22" r="3" fill="#FAF6E8" stroke={stroke} strokeWidth="1.4" />
          <circle className="puff p2" cx="38" cy="14" r="2.4" fill="#FAF6E8" stroke={stroke} strokeWidth="1.4" />
          <circle className="puff p3" cx="26" cy="10" r="2" fill="#FAF6E8" stroke={stroke} strokeWidth="1.4" />
        </g>

        {/* upper lip */}
        <path
          d="M14 38 C20 30, 28 28, 32 32 C36 28, 44 30, 50 38 C46 36, 36 36, 32 38 C28 36, 18 36, 14 38 Z"
          fill="#FF1A8C" stroke={stroke} strokeWidth="2" strokeLinejoin="round"
        />
        {/* lower lip */}
        <path
          d="M14 38 C20 48, 28 50, 32 47 C36 50, 44 48, 50 38 C44 44, 36 46, 32 44 C28 46, 20 44, 14 38 Z"
          fill="#FF4FA3" stroke={stroke} strokeWidth="2" strokeLinejoin="round"
        />
        {/* lip highlight */}
        <path d="M22 41 C26 43, 30 43, 32 42" stroke="#FFD9E8" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.85" />
        {/* tiny tooth-gap */}
        <path d="M30 39 L34 39" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" opacity="0.55" />
      </svg>

      <span
        className="absolute -top-1 -right-1 w-3 h-3 rounded-full"
        style={{ background: "#FFE74C", border: `2px solid ${stroke}` }}
      />
    </span>
  );
}
